import * as React from 'react';
import { IconProps } from 'vet-bones/design-system/components';

export const Ai: React.VFC<IconProps> = ({ size }) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6275 10.1602C19.5773 10.7725 20.597 11.2871 21.6732 11.6904L22.5 12L21.6732 12.3096C17.3466 13.9326 13.9326 17.3467 12.31 21.6728L12 22.5L11.69 21.6728C10.0674 17.3467 6.65344 13.9326 2.32672 12.3096L1.5 12L2.32672 11.6904C6.65344 10.0674 10.0674 6.65332 11.69 2.32714L12 1.5L12.31 2.32714C12.7136 3.40332 13.2279 4.42286 13.8396 5.37208L9.5 7L14.9545 9.0459L17 14.5L18.6275 10.1602Z"
        fill="currentColor"
      />
      <path
        d="M17 2.5L15.7727 5.77272L12.5 7L15.7727 8.22728L17 11.5L18.2273 8.22728L21.5 7L18.2273 5.77272L17 2.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
